<template>
	<div id="material-vendor-stocks-table-main">
		<div class="card mb-3">
			<!-- Bestaende (Qty < 1) -->
			<div class="card-body">
				<div class="d-flex mb-2" id="material-vendor-stocks-top-bar">
					<h3 class="mr-auto" style="margin-bottom: 0px">Bestände</h3>
					<a
						v-if="isMaster"
						class="btn"
						:href="`http://synch.lddmusic.com/material/${material.id}/edit`"
						target="_blank"
					>
						<img src="/images/lddmusic_logo.png" height="30" />
					</a>
					<a
						v-if="isMaster"
						class="mr-1 btn"
						:href="`http://synch.coseon.com/material/${material.id}/edit`"
						target="_blank"
					>
						<img src="/images/coseon.png" height="30" />
					</a>
					<a
						v-if="isMaster"
						class="mr-3 btn"
						:href="`http://synch.wr.mplusl.de/material/${material.id}/edit`"
						target="_blank"
					>
						<img
							src="/images/mymediawelt-logo-bigtransparent.png"
							height="30"
						/>
					</a>
					<button
						type="button"
						class="btn btn-secondary table-secondary mr-3 my-0 py-0"
						size="sm"
						@click="
							synch.openMultipleTabs([
								'https://www.amazon.co.uk/gp/product/' + material.asin,
								'https://www.amazon.de/gp/product/' + material.asin,
								'https://www.amazon.fr/gp/product/' + material.asin,
							])
						"
					>
						<!-- button -->
						<span>Bei Amazon nachbestellen</span>
					</button>
				</div>
				<table class="table table-sm table-hover mb-0" id="material-vendor-stock-table-ohne-bestand">
					<thead>
						<tr>
							<th scope="col">Lieferant</th>
							<th scope="col">ArticleId</th>
							<th scope="col">Zustand</th>
							<th scope="col" style="width: 120px">EK</th>
							<th scope="col">Eingangsporto</th>
							<th scope="col">Summe</th>
							<th scope="col">Bestand</th>
							<th scope="col">Lieferklasse</th>
							<th scope="col">SKU</th>
							<th scope="col" style="width: 80px"><!-- Edit --></th>
						</tr>
					</thead>
					<tbody>
						<material-vendor-stock-table-row
							v-for="stock in stocksWithInventory"
							:stock="stock"
							:stocks="material.stocks"
							:candidateStock="candidateStock"
							:authorization="authorization"
							:key="stock.id"
							:userName="userName"
							@openManualVendorOrder="openManualVendorOrder"
							@openVendorStockBlock="openVendorStockBlock"
						></material-vendor-stock-table-row>
						<tr>
							<td colspan="11">
								<h3 class="mt-2">Ohne Bestand</h3>
							</td>
						</tr>
						<material-vendor-stock-table-row
							v-for="stock in stocksWithoutInventory"
							:stock="stock"
							:stocks="material.stocks"
							:candidateStock="candidateStock"
							:authorization="authorization"
							:key="stock.id"
							:userName="userName"
							@openManualVendorOrder="openManualVendorOrder"
							@openVendorStockBlock="openVendorStockBlock"
						></material-vendor-stock-table-row>
					</tbody>
				</table>
			</div>
		</div>
      	<b-modal
			id="modal-manual-vendor-order"
			v-model="modalManualVendorOrder.state"
			centered
			title="Manuelle Händlerbestellung"
			no-close-on-esc
			no-close-on-backdrop
			hide-header-close
		>
         <div v-if="modalManualVendorOrder.stock != null">
            <form class="px-3">
               <div class="form-group row my-2">
                     <label class="control-label col-4">Lieferant</label>
                     <label class="control-label col-8 px-0"><b>{{modalManualVendorOrder.stock.vendor.name}}</b></label>
               </div>
               <div class="form-group row my-2">
                     <label class="control-label col-4">Barcode (EAN)</label>
                     <label class="control-label col-8 px-0">{{material.ean}}</label>
               </div>
               <div class="form-group row my-2">
                  <label class="control-label col-4">Anzahl</label>
                  <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" v-model="modalManualVendorOrder.quantity">
               </div>
               <div class="form-group row my-2">
                  <label class="control-label col-4">Referenz</label>
                  <input type="text" style="text-align: right;" class="form-control form-control-sm col-8" v-model="modalManualVendorOrder.reference">
               </div>
            </form>
         </div>
		 <div slot="modal-footer" class="w-100">
			<b-button 
				size="md"
				variant="primary"
				class="float-right"
				@click="modalManualVendorOrder.placeOrder()"
			>Bestätigen</b-button>
			<b-button
				size="md"
				class="float-right mx-1"
				variant="secondary"
				@click="modalManualVendorOrder.abort()"
			>Abbrechen</b-button>
		</div>
      	</b-modal>
		<material-vendor-stock-block-component 
			:passedStock="passingStock" 
			:openVendorStockBlockModal="openVendorStockBlockModal"
			@closedVendorStockBlock="closedVendorStockBlock"
			@updateStock="emit_updateStock"
			@error="showErrorModal"
		></material-vendor-stock-block-component> <!--open(stock)-->
		<modal-error-component v-model="modalError"></modal-error-component>
	</div>
</template>
<script>
export default {
	props: [
		"authorization",
		"isMaster",
		"material",
		"userName",
	],
	data() {
		return {
			candidateStock: {
				articleId: null,
				editId: null,
				saveId: null,
				purchasePrice: null, //old values, if aborted
				quantity: null,
			},
			openVendorStockBlockModal: false,
			passingStock: null,
			modalError: {
				show: false,
				title: '',
				error: '',
				message: ''
         	},
			modalManualVendorOrder: {
				state: false,
				stock: null,
				quantity: null,
				reference: null,
				abort: () => {
					this.modalManualVendorOrder.stock = null;
					this.modalManualVendorOrder.quantity = null;
					this.modalManualVendorOrder.reference = null;
					this.modalManualVendorOrder.state = false;
				},
				placeOrder: () => {
					let qty = null;
					try {
						qty = Number(this.modalManualVendorOrder.quantity);
					} catch(error) {
						this.$bvToast.toast( `Anzahl »${this.modalManualVendorOrder.quantity}« muss ganzzahlige Zahl (...,-2,-1,0,1,2,3,...) sein`, {
							title: "Manuelle Bestellung",
							autoHideDelay: 5000,
							appendToast: false,
							variant: 'danger',
						});
						return;
					}

					if(["", null, undefined].includes(this.modalManualVendorOrder.quantity) || isNaN(this.modalManualVendorOrder.quantity) || (qty != Math.floor(qty))) 
					{
						this.$bvToast.toast( `Anzahl »${this.modalManualVendorOrder.quantity}« muss ganzzahlige Zahl (...,-2,-1,0,1,2,3,...) sein`, {
							title: "Manuelle Bestellung",
							autoHideDelay: 5000,
							appendToast: false,
							variant: 'danger',
						});
						return;
					}

					if(["", null, undefined].includes(this.modalManualVendorOrder.reference))
					{
						this.$bvToast.toast( "Referenz darf nicht leer sein.", {
							title: "Manuelle Bestellung",
							autoHideDelay: 5000,
							appendToast: false,
							variant: 'danger',
						});
						return;
					}

					this.modalManualVendorOrder.state = false;

					const payload = {
						stock: this.modalManualVendorOrder.stock,
						material: this.material,
						reference: this.modalManualVendorOrder.reference,
						quantity: this.modalManualVendorOrder.quantity
					};

					axios.post("/material/manualvendororder", payload)
					.then( this.modalManualVendorOrder.abort )
					.catch( err => {
						console.error(err);
						this.$bvToast.toast( "Fehler (Manual Vendor Order): konnte Request nicht durchführen.", {
							title: "Fehler",
     						noAutoHide: true,
							appendToast: false,
							variant: 'danger'
						});
					});
				}
			},

		};
	},
	computed: {
		stocksWithoutInventory: function () {
			return this.material.stocks
				.map( stock => {
					stock.sumPurchasePriceAndShippingFee = Number(stock.vendorShippingFee) + Number(stock.purchasePrice);
					stock.sumPurchasePriceAndShippingFeeStr = Number(
						stock.sumPurchasePriceAndShippingFee
					).toFixed(2);
				return stock;
				})
				.filter( stock => stock.quantity <= 0)
				.sort(this.stockSortComparator);
		},
		stocksWithInventory: function () {
			return this.material.stocks
				.map( stock => {
					stock.sumPurchasePriceAndShippingFee =
						Number(stock.vendorShippingFee) + Number(stock.purchasePrice);
					stock.sumPurchasePriceAndShippingFeeStr = Number(
						stock.sumPurchasePriceAndShippingFee
					).toFixed(2);
					return stock;
				})
				.filter( stock => stock.quantity > 0)
				.sort(this.stockSortComparator);
		},
	},
	methods: {
		stockSortComparator(v, w) {
			return v.sumPurchasePriceAndShippingFee - w.sumPurchasePriceAndShippingFee;
		},
		openManualVendorOrder(stock) {
			this.modalManualVendorOrder.state = true;
			this.modalManualVendorOrder.stock = stock;
    },
		openVendorStockBlock(stock) {
			this.openVendorStockBlockModal = true;
			this.passingStock = stock;
			// console.log('table emit, open modal + passing stock');
		},
		closedVendorStockBlock(){
			this.openVendorStockBlockModal = false;
			// console.log('modal was closed');
		},
		emit_updateStock(stockIds, mode){
			let stocks = this.material.stocks.filter(stock => stockIds.includes(stock.id))

			if(mode === 'created'){
				stocks.forEach(stock => {stock.vendorStockBlock = true; stock.quantity = 0;});
			} else {
				stocks.forEach(stock => {stock.vendorStockBlock = false});
			}

			this.$emit('updateStock', stocks);
		},
		showErrorModal(_title = '', _error = '', _message = ''){
			this.modalError = {
				show: true,
				title: _title,
				error: _error,
				message: _message
      };
		},
	}
};
</script>
